
import * as net from "@ivanlog/net";
import {NBResult} from "./models";
import {OkResult} from "./models";
import {AuthRequest} from "./models";

export class AuthService {
	private readonly _client: net.HTTPClient;
	private readonly _errorsHandler: (e: unknown, args?: unknown) => void;
	/**
	* @param {net.HTTPClient} _client - 
	* @param {(e: unknown, args?: unknown) => void} _errorsHandler - 
	*/
	constructor (_client: net.HTTPClient, _errorsHandler: (e: unknown, args?: unknown) => void){
		this._client = _client;
		this._errorsHandler = _errorsHandler;
		if (!this._errorsHandler) this._errorsHandler = (e, args) => { throw e; };
	}
	
	public async getSidUnsafe(): Promise<NBResult|string|net.NetError|number> {
		const __endpoint="/AuthService/GetSid";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'text/plain,application/json';
		let __url = __endpoint;
		const __response = await this._client.process(net.HTTPMethods.GET, __url, undefined, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: __result = await __response.text(); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<string|undefined>}
	*/
	public async getSid(errHndlArgs?: unknown): Promise<string|undefined> {
		try {
			const r = await this.getSidUnsafe();
			if (typeof r !== "string") throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {string} sid - 
	* @returns {Promise<NBResult|OkResult|net.NetError|number>}
	*/
	public async checkAuthUnsafe(sid: string): Promise<NBResult|OkResult|net.NetError|number> {
		const __endpoint="/AuthService/CheckAuth";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		__addHeaders['Content-Type'] = 'application/json';
		let __url = __endpoint;
		let __data;
		const __bodyDataObj = {} as any;
		__bodyDataObj.sid = sid;
		__data = net.def.objToClearJSON(__bodyDataObj);
		const __response = await this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: __result = new OkResult(await __response.json()); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {string} sid - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<OkResult|undefined>}
	*/
	public async checkAuth(sid: string, errHndlArgs?: unknown): Promise<OkResult|undefined> {
		try {
			const r = await this.checkAuthUnsafe(sid);
			if (!(r instanceof OkResult)) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
	
	/**
	* @param {AuthRequest} request - 
	* @returns {Promise<NBResult|OkResult|net.NetError|number>}
	*/
	public async authUnsafe(request: AuthRequest): Promise<NBResult|OkResult|net.NetError|number> {
		const __endpoint="/AuthService/Auth";
		const __query:string[]=[];
		const __addHeaders: Record<string,string> = {};
		__addHeaders['Accept'] = 'application/json';
		__addHeaders['Content-Type'] = 'application/json';
		let __url = __endpoint;
		let __data;
		const __bodyDataObj = {} as any;
		__bodyDataObj.request = request;
		__data = net.def.objToClearJSON(__bodyDataObj);
		const __response = await this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200]);
		const __code: number = __response.status;
		let __result;
		try {
			switch(__code) {
				case 200: __result = new OkResult(await __response.json()); break;
				case 401: __result = new NBResult(await __response.json()); break;
				case 403: __result = new NBResult(await __response.json()); break;
				case 422: __result = new NBResult(await __response.json()); break;
				case 500: __result = new NBResult(await __response.json()); break;
				default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
			}
		} catch(e) { throw new net.NetError(net.HTTPCodes.BadDataFormat); }
		if ((__code>=200)&&(__code<300))
		{ if (__result) return __result; else return __code; } else
		{ if (__result) throw __result; else throw new net.NetError(__code); }
	}
	
	/**
	* @param {AuthRequest} request - 
	* @param {unknown} errHndlArgs? - args for errorsHandler
	* @returns {Promise<OkResult|undefined>}
	*/
	public async auth(request: AuthRequest, errHndlArgs?: unknown): Promise<OkResult|undefined> {
		try {
			const r = await this.authUnsafe(request);
			if (!(r instanceof OkResult)) throw new net.NetError(net.HTTPCodes.UnknownResponse); else return r;
		} catch (e) { this._errorsHandler(e, errHndlArgs); }
	}
}
